import Vue from 'vue';
import showResponseError from './showResponseError';
import stzhToastbar from './stzhToastbar';
import isPermitted from './isPermitted';
import sanitizedContent from './sanitizedContent';
import lsz from './lsz';
import common from './common';

// register global mixins
Vue.mixin(showResponseError);
Vue.mixin(stzhToastbar);
Vue.mixin(isPermitted);
Vue.mixin(sanitizedContent);
Vue.mixin(lsz);
Vue.mixin(common);

export default {};
export { default as mixinToggleDropdown } from './toggleDropdown';
export { default as mixinMouseEnterLeave } from './mouseEnterLeave';
export { default as mixinRefreshTableOrDetailView } from './refreshTableOrDetailView';
